import { Buffer } from "buffer";

declare global {
  interface Window {
    Buffer: typeof Buffer;
    global: typeof globalThis;
    process: NodeJS.Process;
  }
}

window.Buffer = Buffer;
window.global = window as any;

if (typeof window.process === "undefined") {
  window.process = { env: {} } as NodeJS.Process;
}
